import { runnerApi } from '../../../axios'
import { apiErrorHandler } from '../../../utils/api-error-handler'
import type {
  StartRunnerTimesnapParams,
  UpdateRunnerParams,
} from '../model/params'

export const startRunnerTimesnap = async ({
  rundownId,
  runnerId,
  params,
}: StartRunnerTimesnapParams) => {
  return await apiErrorHandler(
    runnerApi.post(`/${rundownId}/${runnerId}/timesnap/start`, null, {
      params,
    }),
  )
}

export const updateRunner = async ({
  rundownId,
  runnerId,
  payload,
}: UpdateRunnerParams) => {
  return await apiErrorHandler(
    runnerApi.put(`/${rundownId}/${runnerId}`, payload),
  )
}

type SubTimerRunParams = {
  rundownId: string
  runnerId: string
  cueId: string
  timerId: string
}

const subTimerPath = ({ rundownId, runnerId, timerId }: SubTimerRunParams) =>
  `/${rundownId}/${runnerId}/sub-timers/${timerId}`

export const toggleSubTimerRun = async (params: SubTimerRunParams) => {
  return await apiErrorHandler(
    runnerApi.post(`${subTimerPath(params)}/toggle`, { cueId: params.cueId }),
  )
}

export const resetSubTimerRun = async (params: SubTimerRunParams) => {
  return await apiErrorHandler(
    runnerApi.post(`${subTimerPath(params)}/reset`, { cueId: params.cueId }),
  )
}
